import { Injectable, OnDestroy } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { from, interval, Subject } from 'rxjs';
import { concatMap, switchMap, takeUntil, timeout } from 'rxjs/operators';
import { NewVersionSnackbarComponent } from 'src/features/common/cad-app/view/new-version-snackbar/new-version-snackbar.component';

@Injectable()
export class ClientUpdatedService implements OnDestroy {
  private unSub: Subject<void> = new Subject();
  private stopUpdateCheckerSub: Subject<void> = new Subject<void>();
  private readonly versionPollingInterval: number = 600000; // 10 minute period

  constructor(
    private swUpdate: SwUpdate,
    private matSnackBar: MatSnackBar) {}

  ngOnDestroy(): void {
    this.unSub.next();
    this.unSub.complete();
    this.stopUpdateChecker();
  }

  initNewVersionPolling(): void {
    interval(this.versionPollingInterval)
      .pipe(
        takeUntil(this.stopUpdateCheckerSub),
        concatMap(() => from(this.swUpdate.checkForUpdate()).pipe(timeout(this.versionPollingInterval / 2))))
      .subscribe(
        () => {},
        () => this.stopUpdateChecker());

    this.swUpdate.available.pipe(
      switchMap(() => from(this.swUpdate.activateUpdate())))
    .subscribe(()=> {
      this.stopUpdateChecker();
      let sbRef=
        this.matSnackBar.openFromComponent(NewVersionSnackbarComponent,{ panelClass:[ 'snackbar-party' ] });
      sbRef.instance.sbRef = sbRef;
    });
  }

  private stopUpdateChecker(): void {
    this.stopUpdateCheckerSub.next();
    this.stopUpdateCheckerSub.complete();
  }
}
